<template lang="pug">
  div.subscribe(v-if="logged")
    .subscribeCon.layout_screen_width
      subscribe-nav
      div.router-view(@scroll="scrollEvent" :class="{hideScroll:hideScroll}")
        router-view
      div.footer
        easy-footer
</template>
<script>
import SubscribeNav from './SubscribeNav'
import EasyFooter from '../components/EasyFooter'
export default {
  name: 'EventIndexSubScribe',
  components: {
    SubscribeNav,
    EasyFooter
  },
  computed: {
    user () {
      return this.$store.state.user
    }
  },
  data () {
    return {
      scrollTop: 0,
      hideScroll: true,
      timeOut: null
    }
  },
  methods: {
    // 滚动的时候显示滚动条
    scrollEvent (event) {
      let newScrollTop = event.target.scrollTop
      if (newScrollTop - this.scrollTop !== 0) {
        this.scrollTop = newScrollTop
        this.hideScroll = false
        clearTimeout(this.timeOut)
        this.timeOut = setTimeout(() => {
          this.hideScroll = true
          clearTimeout(this.timeOut)
        }, 500)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.subscribe {
  width: 100%;
  height: 100%;
  background-color: #e8ebf1;
  .subscribeCon {
    position: relative;
    overflow: auto;
    width: 100%;
    height: 100%;
    padding: 24px 0;
    display: flex;
  }
  .router-view {
    height: 100%;
    overflow-y: auto;
    flex: 1;
    display: flex;
    margin-left: 20px;
  }
  .hideScroll::-webkit-scrollbar-thumb {
    background-color: transparent;
  }
  .footer {
    position: absolute;
    bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/EventIndex/SubscribeVip.vue